require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-during-fy-26-appropriations-congress-should-recogni.json") })
        }
      }, "path---en-us-update-during-fy-26-appropriations-congress-should-recogni");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-during-fy-26-appropriations-congress-should-recogni!./.cache/json/en-us-update-during-fy-26-appropriations-congress-should-recogni.json
// module id = 660
// module chunks = 231608221292675